import { createContext, useContext, useEffect, useState } from 'react';

// ❌ NÃO PRECISA importar useComparador aqui
// import { useComparador } from '../context/ComparadorContext';

const ComparadorContext = createContext();

export function ComparadorProvider({ children }) {
  const [imoveisSelecionados, setImoveisSelecionados] = useState([]);

  useEffect(() => {
    const salvo = localStorage.getItem('comparador');
    if (salvo) {
      setImoveisSelecionados(JSON.parse(salvo));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('comparador', JSON.stringify(imoveisSelecionados));
  }, [imoveisSelecionados]);

  function adicionarImovel(id) {
    if (imoveisSelecionados.includes(id)) return;
    if (imoveisSelecionados.length >= 4)
      return alert('Você só pode comparar até 4 imóveis.');
    setImoveisSelecionados([...imoveisSelecionados, id]);
  }

  function removerImovel(id) {
    setImoveisSelecionados(imoveisSelecionados.filter((item) => item !== id));
  }

  function limparComparador() {
    setImoveisSelecionados([]);
  }

  return (
    <ComparadorContext.Provider
      value={{
        imoveisSelecionados,
        adicionarImovel,
        removerImovel,
        limparComparador,
      }}
    >
      {children}
    </ComparadorContext.Provider>
  );
}

export function useComparador() {
  return useContext(ComparadorContext);
}
